'use client';

import {
  BarChart3,
  Calendar,
  FileText,
  Repeat,
  Settings2,
  Shield,
  Users,
  type LucideIcon,
} from 'lucide-react';

import {
  ConceptsSection,
  HelpPage,
  IntroSection,
  RolesSection,
  TasksSection,
} from '@/components/help';
import { useTranslation } from '@/hooks/useTranslation';

const TASK_ICONS: Record<string, LucideIcon> = {
  dashboard: BarChart3,
  meetings: Calendar,
  series: Repeat,
  templates: FileText,
  reports: BarChart3,
  users: Users,
  auditLogs: Shield,
  outlookSync: Settings2,
};

const TASK_PATHS: Record<string, string> = {
  dashboard: '/meetingattendance/dashboard',
  meetings: '/meetingattendance/meetings',
  series: '/meetingattendance/series',
  templates: '/meetingattendance/templates',
  reports: '/meetingattendance/reports',
  users: '/meetingattendance/users',
  auditLogs: '/meetingattendance/audit-logs',
  outlookSync: '/meetingattendance/integrations/outlook',
};

export default function MeetingAttendanceHelpPage() {
  const { t } = useTranslation();
  const help = t.meetingAttendance.help;

  return (
    <HelpPage title={help.title} subtitle={help.subtitle}>
      <IntroSection
        title={help.intro.title}
        paragraph={help.intro.paragraph}
        highlights={help.intro.highlights}
      />

      <ConceptsSection
        title={help.concepts.title}
        description={help.concepts.description}
        items={help.concepts.items}
      />

      <RolesSection
        title={help.roles.title}
        description={help.roles.description}
        columnHeaders={help.roles.columnHeaders}
        items={help.roles.items}
      />

      <TasksSection
        title={help.tasks.title}
        description={help.tasks.description}
        cards={help.tasks.cards.map((c) => ({
          ...c,
          path: TASK_PATHS[c.id] ?? '#',
          icon: TASK_ICONS[c.id],
        }))}
      />
    </HelpPage>
  );
}
